import React from 'react';
import tw from 'twin.macro';
import SchoolyearLink from '@teetsh/app/src/components/Link/SchoolyearLink';
import { ChartBarIcon as ChartBar } from '@heroicons/react/24/outline';
import { useLocation } from 'react-router-dom';
import { ClipboardDocumentListIcon as ClipboardList } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

const CliboardIcon = () => <ClipboardList tw="h-5 w-5 mr-2" />;
const ChartBarIcon = () => <ChartBar tw="h-5 w-5 mr-2" />;

export const REGISTRE_HEADER_HEIGHT = 53;

export function Header() {
  const location = useLocation();
  const { t } = useTranslation(['registreAppel']);
  const navigation = [
    {
      name: (
        <>
          <CliboardIcon />
          {t('registreAppel:registreAppel')}
        </>
      ),
      to: 'registre-appel/appels',
      isCurrent: pathName => pathName.includes('registre-appel/appels'),
    },
    {
      name: (
        <>
          <ChartBarIcon />
          {t('registreAppel:statistiques')}
        </>
      ),
      to: 'registre-appel/stats',
      current: false,
      isCurrent: pathName => pathName.includes('registre-appel/stats'),
    },
  ];

  return (
    <nav
      tw="hidden md:py-2 md:flex md:space-x-6 bg-white px-6 border-b"
      aria-label="Planner navigation"
    >
      {navigation.map(item => (
        <SchoolyearLink
          key={item.to}
          css={[
            tw`rounded-md py-2 px-3 inline-flex items-center text-sm font-medium text-neutral-intense`,
            item.isCurrent(location.pathname) &&
              tw`bg-neutral-quiet text-neutral-intense`,
            tw`hover:bg-neutral-supershy hover:text-neutral-intense`,
          ]}
          aria-current={item.current ? 'page' : undefined}
          to={item.to}
        >
          {item.name}
        </SchoolyearLink>
      ))}
    </nav>
  );
}
